import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import SaveAccountForm from '../components/SaveAccountForm';
import { getBank } from '../redux/modules/bank';
import { getaddress } from '../redux/modules/address';
import { createAccount } from '../redux/modules/account';
import { notifSend } from '../redux/modules/notifs';
import { MESSAGES } from '../strings';

export class SaveAccount extends Component {
  static propTypes = {
    bankDetails: PropTypes.object,
    loading: PropTypes.bool,
    error: PropTypes.string,
    user: PropTypes.object.isRequired,
    createAccount: PropTypes.func.isRequired,
    getBank: PropTypes.func.isRequired,
    getaddress: PropTypes.func.isRequired,
    notifSend: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
    router: PropTypes.object.isRequired,
    zipCode: PropTypes.array,
  };

  static defaultProps = {
    loading: false,
    error: null,
    bankDetails: null,
    zipCode: null,
  };

  componentWillReceiveProps = (nextProps) => {
    const { error, notifSend } = nextProps;
    if (error) {
      notifSend({
        message: error,
        kind: 'danger',
      });
    }
  };

  handleSaveAccount = (data) => {
    const { createAccount } = this.props;
    return createAccount(data).then(this.successSaveAccount);
  };

  successSaveAccount = (data) => {
    const { router, error } = this.props;
    if (!error) {
      router.push(
        `/operationComplete?message=${MESSAGES.ACCOUNT_SAVED}&buttonText=${'Submit payment'}`,
      );
    }
    return data;
  };

  handleChangeRoutingNumber = _.debounce((event) => {
    const routingNumber = _.get(event, 'target.value');
    const { getBank } = this.props;
    if (_.size(routingNumber) === 9) {
      getBank(routingNumber);
    }
  }, 500);
  handleZipCodeChange = _.debounce((event) => {
    const zipCode = _.get(event, 'target.value');
    const { getaddress } = this.props;
    if (_.size(zipCode) === 5) {
      getaddress(zipCode);
    }
  }, 500);

  render() {
    const { loading, user, bankDetails, zipCode } = this.props;

    return (
      <div className="container">
        <Helmet title="Save Account" />
        <SaveAccountForm
          user={user}
          bankDetails={bankDetails}
          zipCode={zipCode}
          onSubmit={this.handleSaveAccount}
          onChangeRoutingNumber={this.handleChangeRoutingNumber}
          onZipCodeChange={this.handleZipCodeChange}
          disableSubmit={loading}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    user: state.auth.user,
    loading: state.account.loading,
    error: state.account.error,
    bankDetails: state.bank.details,
    zipCode: state.address.zipCode,
  }),
  {
    getBank,
    createAccount,
    notifSend,
    getaddress,
  },
)(SaveAccount);
